import React, { useEffect, useRef, useState, useMemo } from "react";
import { Link } from "react-router-dom";
import { Button, message, Skeleton, Space, Tabs } from "antd";
import Icon, { WechatOutlined } from "@ant-design/icons";
import "../login-register-forget.less";
import { event, lib } from "react-single-app";
import useRootPath from "../../components/hook/useRootPath";
import HintChangePassword from "../../components/hint-change-password";
import { ADMIN, loginRoleList, USER } from "../select-role";
import QYWechatOutlined from "../../components/QYWechatOutlined";
import useOauth from "../../components/hook/useOauth";
import { PLATFORM_CODE } from "../oauth/types";
import { PcLoginPanel } from "./pc-login-panel";
import { loginSuccess } from "../../utiis/common";
import { ReactComponent as QyWechatWhite } from "../../asset/image/icon_qy_wechat_white.svg";

export function Send({ data, size = "large" }) {
    let [time, setTime] = useState(0);
    let [now, setNow] = useState(new Date().getTime());
    useEffect(() => {
        const timer = setInterval(() => {
            setNow(new Date().getTime());
        }, 1000);
        return () => clearInterval(timer);
    }, []);
    let leftTime = parseInt((time - now + 60 * 1000) / 1000);
    const { host } = window.location;
    let formData = {
        ...data,
        domain: host,
    };
    return (
        <div
            className={`send-code ${size} ${leftTime > 0 && "count-down"}`}
            onClick={() => {
                if (leftTime < 0) {
                    lib.request({
                        url: "/ucenter-account/sms/send",
                        data: formData,
                        needMask: true,
                        success: data => {
                            setTime(new Date().getTime());
                            message.success("手机验证码发送成功");
                        },
                        fail: (code, message) => {
                            console.log(code, message);
                            if (code == -1 && message == "图形验证码错误!") {
                                console.log("event");
                                event.emit("refresh-image");
                            }
                        },
                    });
                }
            }}>
            {leftTime > 0 ? leftTime : "获取验证码"}
        </div>
    );
}

export function MyLink({ role }) {
    const rootPath = useRootPath();
    return (
        lib.config.webToken == "user" &&
        role === USER && (
            <div style={{ height: "22px", position: "relative", zIndex: 200 }}>
                <Link to={`${rootPath}/register?type=2`}>注册企业帐号</Link>
                <Link style={{ float: "right" }} to={`${rootPath}/register?type=3`}>
                    员工注册子帐号
                </Link>
            </div>
        )
    );
}

export function LoginBg() {
    return (
        <div className={"login-bg"}>
            <div className={"left-top-bg"} />
            <div className={"top-center-bg"} />
            <div className={"right-center-bg"} />
            <div className={"left-bottom-bg"} />
        </div>
    );
}

export const Header = props => {
    document.title = props.saasInfo.systemName;
    return (
        <>
            {props.loading ? (
                <Skeleton
                    avatar
                    paragraph={{
                        rows: 0,
                    }}
                    className="skeleton-logo"
                />
            ) : (
                <div className="logo">
                    <img src={`${props.saasInfo.logo}`} />
                    {props.saasInfo.systemName}
                </div>
            )}
        </>
    );
};

function Login(props) {
    /**
     * 上一次登录的系统，
     */
    const loginSystem = useRef("");
    const rootPath = useRootPath();
    const [role, setRole] = useState(localStorage.getItem("role"));
    const [roleName, setRoleName] = useState(localStorage.getItem("roleName"));
    const [hintChangePassword, setHintChangePassword] = useState(false);
    const [showOathLoginBtn, setShowOathLoginBtn] = useState(() => window.isWxWork);
    const { toOauth } = useOauth({
        rootPath: rootPath,
        loginIdentity: role,
    });
    useEffect(() => {
        if (!localStorage.getItem("role")) {
            location.href = `/select-role${location.search}`;
        } else {
            //选择角色页面记录的角色
            let roleName = localStorage.getItem("roleName");
            let roleType = localStorage.getItem("role");
            //退出登录时传递的角色（必须保证传参是正确的）
            let loginRole = lib.getParam("loginRole");
            if (loginRole) {
                loginRoleList.map(item => {
                    if (loginRole === item.role) {
                        roleName = item.title;
                    }
                });
                roleType = loginRole;
            }
            setRoleName(roleName);
            setRole(roleType);
        }
    }, []);

    function jumpPage() {
        let redirectUrl = loginSystem.current;
        loginSuccess(redirectUrl);
    }

    const thirdLoginTip = useMemo(() => {
        let wxLoginUrl = `${rootPath}/wxLogin?loginIdentity=${role}`;
        let QYWxLoginUrl = `${rootPath}/qy-wx-login?loginIdentity=${role}`;
        return props.saasInfo?.tenantId === 1001 ? (
            <div className={"third-login-tip"}>
                <span>第三方账号登录</span>
                <div className={"wechat-wrapper"} onClick={() => (window.location = wxLoginUrl)}>
                    <WechatOutlined className={"wechat-icon"} />
                </div>
                {role !== "user" && (
                    <div
                        className={"qiyewechat-wrapper"}
                        onClick={() => {
                            if (window.isWxWork) {
                                toOauth(role, PLATFORM_CODE.QyWx);
                            } else {
                                window.location = QYWxLoginUrl;
                            }
                        }}>
                        <QYWechatOutlined iconClassName={"wechat-icon"} />
                    </div>
                )}
            </div>
        ) : null;
    }, [rootPath, role, props.saasInfo]);

    return (
        <>
            <LoginBg />
            <Header saasInfo={props.saasInfo} loading={props.loading} />
            <div className={"login-container"}>
                {props.saasInfo.loginPic ? (
                    <img
                        src={props.saasInfo.loginPic}
                        height={"395"}
                        width={"520"}
                        className={"left-bg"}
                    />
                ) : (
                    <div style={{ width: "520px", height: "395px" }}></div>
                )}

                <div className={"login-wrap"}>
                    <div className="login-switch">
                        <div className="role-name">{roleName}</div>
                        <div
                            className="switch-btn"
                            onClick={() => {
                                if (window.isWxWork) {
                                    location.href = "/oauth-middle-page";
                                } else {
                                    location.href = "/select-role" + location.search;
                                }
                                localStorage.removeItem("role");
                                localStorage.removeItem("roleName");
                            }}>
                            <img src="https://dante-img.oss-cn-hangzhou.aliyuncs.com/21934613682.svg" />
                            切换身份
                        </div>
                    </div>
                    <div className="lpr-content">
                        {(!showOathLoginBtn || role === USER) && (
                            <>
                                <PcLoginPanel
                                    role={role}
                                    rootPath={rootPath}
                                    loginSuccess={res => {
                                        // loginSystem.current = res?.loginSystem;
                                        loginSystem.current = res;
                                        //后端返回上一次登录的系统
                                        if (res.needUpdatePwd) {
                                            setHintChangePassword(true);
                                        } else {
                                            jumpPage();
                                        }
                                    }}
                                />
                            </>
                        )}
                        {window.isWxWork && role !== USER ? (
                            <>
                                {showOathLoginBtn && (
                                    <div className={"oauth-login"}>
                                        <Button
                                            type="primary"
                                            size="large"
                                            className={"oauth-btn-login"}
                                            onClick={() => toOauth(role, PLATFORM_CODE.QyWx)}>
                                            <Icon
                                                component={QyWechatWhite}
                                                className={"wechat-icon"}
                                            />{" "}
                                            企业微信登录
                                        </Button>
                                    </div>
                                )}
                                <Space className="login-type">
                                    <div
                                        className={"link"}
                                        onClick={() => {
                                            setShowOathLoginBtn(!showOathLoginBtn);
                                        }}>
                                        {showOathLoginBtn
                                            ? "密码登录/验证码登录 >"
                                            : "企业微信登录 >"}
                                    </div>
                                </Space>
                            </>
                        ) : (
                            <>
                                {thirdLoginTip}
                                {role === ADMIN ? (
                                    <Link
                                        style={{ float: "right" }}
                                        to={`${rootPath}/forget`}
                                        className={"clearfix"}>
                                        忘记密码？
                                    </Link>
                                ) : null}
                            </>
                        )}
                        <div className={"clearfix"} />
                        <div className="privacy-div">
                            登录即代表你已阅读并同意
                            <Link to={`${rootPath}/service-agreement`}>服务协议</Link>和
                            <Link to={`${rootPath}/privacy`}>隐私条款</Link>
                        </div>
                    </div>
                </div>
            </div>
            <HintChangePassword
                visible={hintChangePassword}
                onHandle={() => {
                    setHintChangePassword(false);
                }}
                jumpPage={jumpPage}
            />
        </>
    );
}

export default Login;
